import { Box, BoxProps, Input } from "@chakra-ui/react"
import {
  TYPESENSE_SEARCH_PARAMETERS,
  TYPESENSE_SERVER_CONFIG,
} from "@common/Typesense"
import DefaultSections from "@components/Layouts/DefaultSections"
import Breadcrumbs from "@components/Product/Breadcrumbs"
import VirtualRefinementList from "@components/Search/Filters/VirtualRefinementList"
import VirtualSearchBox from "@components/Search/Filters/VirtualSearchBox"
import { noop } from "instantsearch.js/es/lib/utils"
import { useRouter } from "next/compat/router"
import singletonRouter from "next/router"
import {
  InstantSearch,
  InstantSearchServerState,
  InstantSearchSSRProvider,
} from "react-instantsearch-core"
import { createInstantSearchRouterNext } from "react-instantsearch-router-nextjs"
import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter"

const searchClient = new TypesenseInstantSearchAdapter({
  server: TYPESENSE_SERVER_CONFIG,
  additionalSearchParameters: {
    ...TYPESENSE_SEARCH_PARAMETERS,
    per_page: 12,
  },
}).searchClient

type SearchPageProps = {
  serverState?: InstantSearchServerState
  serverUrl?: string | undefined
  slug: string
}

const AuthorLayout = ({
  serverUrl,
  serverState,
  slug,
  children,
  ...props
}: BoxProps & SearchPageProps) => {
  const router = useRouter()

  const breadcrumbs = [
    {
      name: slug,
      termCode: "BISAC",
    },
  ]

  const authorRefinement: {
    [key: string]: string[]
  } = {
    "author.en_AE": [slug],
  }

  return (
    <DefaultSections>
      <Breadcrumbs
        showFirst={true}
        category={breadcrumbs}
        catPage
      />
      <Input
        placeholder={"Search"}
        enterKeyHint={"search"}
        onFocus={() => {
          router?.push(`/s`).then(noop)
        }}
      />
      <InstantSearchSSRProvider {...serverState}>
        <InstantSearch
          initialUiState={{
            products: {
              refinementList: authorRefinement,
            },
          }}
          indexName={"products"}
          searchClient={searchClient}
          routing={{
            router: createInstantSearchRouterNext({
              singletonRouter,
              serverUrl,
            }),
            stateMapping: {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              stateToRoute(uiState) {
                const indexUiState = uiState["products"]
                return {
                  q: indexUiState.query,
                  page: indexUiState.page,
                }
              },
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              routeToState(routeState) {
                return {
                  ["products"]: {
                    query: routeState.q,
                    refinementList: authorRefinement,
                    page: routeState.page,
                  },
                }
              },
            },
          }}
        >
          <VirtualSearchBox />
          <VirtualRefinementList attribute={"author.en_AE"} />
          <Box
            mt={4}
            {...props}
          >
            {children}
          </Box>
        </InstantSearch>
      </InstantSearchSSRProvider>
    </DefaultSections>
  )
}

export default AuthorLayout
